import * as React from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import { Results } from "../App";
import { useTheme } from "@mui/material";

interface Props{
    results:Results
}

const Chart: React.FC<Props> = ({results}) => {
    const theme = useTheme()
  return (
    <LineChart
      sx={{maxWidth:1000}}
        margin={{left:70}}
        title="Gráfico"
        tooltip={{ trigger: 'axis' }}
      xAxis={[{ scaleType: "linear", data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] }]}
      series={[
        {
          data: [
            results.first.actual.contribution,
            results.first.actual.contribution * 2,
            results.first.actual.contribution * 3,
            results.first.actual.contribution * 4,
            results.first.actual.contribution * 5,
            results.first.actual.contribution * 6,
            results.first.actual.contribution * 7,
            results.first.actual.contribution * 8,
            results.first.actual.contribution * 9,
            results.first.actual.contribution * 10,
            results.first.actual.contribution * 11,
          ],
          label:'Actual'
        },
        {
            data: [
              results.first.boric.contribution,
              results.first.boric.contribution * 2,
              results.first.boric.contribution * 3,
              results.first.boric.contribution * 4,
              results.first.boric.contribution * 5,
              results.first.boric.contribution * 6,
              results.first.boric.contribution * 7,
              results.first.boric.contribution * 8,
              results.first.boric.contribution * 9,
              results.first.boric.contribution * 10,
              results.first.boric.contribution * 11,
            ],
            label:'Boric',
            color:"red"
          },
          {
            data: [
              results.first.parisi.contribution,
              results.first.parisi.contribution * 2,
              results.first.parisi.contribution * 3,
              results.first.parisi.contribution * 4,
              results.first.parisi.contribution * 5,
              results.first.parisi.contribution * 6,
              results.first.parisi.contribution * 7,
              results.first.parisi.contribution * 8,
              results.first.parisi.contribution * 9,
              results.first.parisi.contribution * 10,
              results.first.parisi.contribution * 11,
            ],
            label:'Parisi',
            color: theme.palette.primary.main
          },
      ]}
      height={300}
    />
  );
};

export default Chart;
